import { render, staticRenderFns } from "./VoiceToneSection.vue?vue&type=template&id=5947a40e&scoped=true"
import script from "./VoiceToneSection.vue?vue&type=script&lang=js"
export * from "./VoiceToneSection.vue?vue&type=script&lang=js"
import style0 from "./VoiceToneSection.vue?vue&type=style&index=0&id=5947a40e&prod&lang=scss&scoped=true"
import style1 from "./VoiceToneSection.vue?vue&type=style&index=1&id=5947a40e&prod&lang=scss"
import style2 from "./VoiceToneSection.vue?vue&type=style&index=2&id=5947a40e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5947a40e",
  null
  
)

export default component.exports